/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogTokenContractInfo = {
    DPL: string;
    CTRXHA: string;
    TKNT: ZerogTokenContractInfo.TKNT;
    DCML: string;
};

export namespace ZerogTokenContractInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

